import React, { useCallback, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  SetProducts,
  SetSort,
  SetPage,
  SetIsSearching,
  SetPrevProducts,
  SetAsyncData,
} from "../../state/actions/index"
import "./SortDropdown.css"
import Utils from "../../utils/Utils"
import axios from "axios"

const SortDropdown = () => {
  const sorts = useSelector((state) => state.config.sorts)
  const filters = useSelector((state) => state.config.filters)
  const card = useSelector((state) => state.config.card)
  const searchWord = useSelector((state) => state.searchWord)
  const activeFilters = useSelector((state) => state.activeFilters)
  const config = useSelector((state) => state.config)
  const isMobile = useSelector((state) => state.isMobile)
  const products = useSelector((state) => state.products)
  const dispatch = useDispatch()

  const queryOptions = useSelector((state) => state.config.queryOptions)
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  )

  const selectOrder = useCallback(
    (sortLabel) => {
      var sortToUse = Utils.getSortFromLabel(sorts, sortLabel.target.value)
      dispatch(SetSort(sortToUse))
      dispatch(SetIsSearching(true))
      dispatch(SetAsyncData([]))
      var priceGroup = {}
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      )
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            searchWord,
            activeFilters,
            sortToUse,
            1,
            filters,
            rows
          )
        )
        .then((response) => {
          let responseData = response.data
          var websiteSearchBar = document.getElementById(
            "accelasearch-bar-container-container"
          )
          const event = new CustomEvent("as-search-event", {
            detail: {
              searchWord: searchWord,
              filters: activeFilters,
              page: 1,
            },
          })
          // websiteSearchBar.dispatchEvent(event)
          dispatch(SetPrevProducts(products))
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                responseData.data,
                responseData.header.imagePrefix,
                responseData.header.urlPrefix,
                card.img,
                card.url
              )
            )
          )
          dispatch(SetPage(1))
          if (config.webhook.key !== "")
            Utils.getAsyncData(
              config.webhook,
              responseData.data,
              priceGroup
            ).then((value) => dispatch(SetAsyncData(value.asyncData)))
          websiteSearchBar.dispatchEvent(event)
        })
        .finally(() => dispatch(SetIsSearching(false)))
    },
    [
      dispatch,
      activeFilters,
      searchWord,
      config,
      sorts,
      filters,
      products,
      rows,
      card,
    ]
  )

  return (
    <div className="sort-dropdown-container">
      <select className="sort-dropdown" onChange={(evt) => selectOrder(evt)}>
        {sorts.map((item, index) => (
          <option
            /* onClick={(item)=>selectOrder(item)} */ key={"sort_" + index}
            value={item.label}
          >
            {item.label}
          </option>
        ))}
      </select>
      <div className="dropdown-icon"></div>
    </div>
  )
}

export default SortDropdown
